// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import promise from 'es6-promise'
promise.polyfill()

import App from './App'
import router from './router'


import GeminiScrollbar from 'vue-gemini-scrollbar'
import Navigation from 'vue-navigation' //前进刷新，后退不刷新依赖,类似于keep-alive
Vue.use(Navigation, {
  router
}, GeminiScrollbar) // 前后顺序不能颠倒，否则会报错

import "../plugins/ztree/js/rem.js";

// 公共组件-->我要报名
import apply from './view/common/apply.vue';
Vue.component("apply",apply)
// 公共组件--> 分享
import shareA from './view/common/share.vue';
Vue.component("shareA",shareA)

import Vant,{Lazyload,Toast} from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.use(Lazyload);


Vue.prototype.Toast = Toast; // 轻提示

Vue.config.productionTip = false; // 阻止显示生产模式的消息
Vue.prototype.Event=new Vue();

import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;


// 防止频繁点击
Vue.prototype.debounce = (func, wait) => {
  let timeout = '';
  return (v) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func(v);
    }, wait);
  }
};


 new Vue({
   el: '#app',
   router,
   render: h => h(App),
   components: {
     App
   }
 })



// WEBPACK FOOTER //
// ./src/main.js